import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { DialogActions, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getUserGroups } from "../../../../services/usersService";
import { changeTicketService } from "../../../../services/crm/ticketService";
import { onPreventEnterSubmitting } from "../../../../utils/utils";
import Swal from "sweetalert2";
const ChangeService = ({
  ticketID,
  groupID,
  groupName,
  onReloadTicket,
  onCloseDialog,
}) => {
  const [userGroups, setUserGroups] = useState([]);
  const serviceData = {
    ticketID,
    groupID,
    groupName,
  };

  useEffect(() => {
    getUserGroupsData();
  }, []);
  const changeServiceFormSchema = yup.object().shape({
    groupID: yup.number(),
    groupName: yup.string().required("Service is required"),
  });
  return (
    <Formik
      initialValues={serviceData}
      validationSchema={changeServiceFormSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to change this Ticket Service ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, change it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              changeTicketService(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Changed",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onReloadTicket(ticketID, values.groupID);
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        dirty,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <Autocomplete
            disableClearable={true}
            inputValue={values.groupName}
            options={userGroups}
            getOptionLabel={(option) => option.groupName}
            onChange={(event, value) => {
              if (value.ID && value.ID !== null) {
                setFieldValue("groupID", value.ID);
                setFieldValue("groupName", value.groupName);
              }
            }}
            onInputChange={(event, value) => {
              setFieldValue("groupName", value);
            }}
            renderInput={(params) => (
              <TextField
                className="kt-width-full"
                {...params}
                label="Service"
                variant="outlined"
                size="small"
                helperText={touched.groupName && errors.groupName}
                error={Boolean(touched.groupName && errors.groupName)}
              />
            )}
          />
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            {dirty ? (
              <button
                type="submit"
                className="btn btn-primary btn-md btn-pill btn-bold"
                disabled={isSubmitting}
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            ) : null}
          </DialogActions>
        </form>
      )}
    </Formik>
  );

  async function getUserGroupsData() {
    const response = await getUserGroups();
    setUserGroups(response.data);
  }
};

export default ChangeService;
